var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('h2',[_c('i'),_c('span',[_vm._v(_vm._s(_vm.$root.t.deposit_now)+":")])]),_vm._v(" "),_c('paymentForm')],_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('h2',[_c('i'),_c('span',[_vm._v(_vm._s(_vm.$root.t.withdraw_now)+":")])]),_vm._v(" "),_c('withdrawForm')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-636ed179","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/gateways/extend.vue
// module id = NBTg
// module chunks = 0